import React, { FC, SyntheticEvent } from "react";

import tw, { TArg as TArgument } from "../../tailwindcss-classnames";
import { Button } from "../button/button";
import { Errors } from "../form/errors";
import { useStandardForm } from "../form/use-standard-form";
import { TextLink } from "../link/text-link";
import { B1, B2 } from "../type/Typography";

import { useFocusFirstChildInput } from "lib/useFocusFirstChildInput";

export interface SignUpFormData {
  email: string;
  password: string;
  passwordRepeat: string;
  acceptsMarketing: boolean;
  acceptsTerms: boolean;
}

const defaultValues: SignUpFormData = {
  email: "",
  password: "",
  passwordRepeat: "",
  acceptsTerms: true,
  acceptsMarketing: false,
};
const fields = [
  "email",
  "password",
  "passwordRepeat",
  "acceptsMarketing",
] as const;

export interface Props {
  onSubmit: (formData: SignUpFormData, event: SyntheticEvent) => void;
  loading: boolean;
  error: any;
}

export const SignUpPageComponent: FC<Props> = (properties) => {
  const reference = useFocusFirstChildInput();
  const { form, getInput, submitButton } = useStandardForm(
    null,
    defaultValues,
    "signup"
  );

  return (
    <div
      className={tw("max-w-screen-container-large", "mx-auto", "px-16", "pb-8")}
      ref={reference}
    >
      <TextLink href={"/login"}>
        <B2
          Component={"div"}
          color="text-gold"
          className={tw(
            "uppercase",
            "py-12",
            "font-bold",
            "text-center",
            "container:py-16"
          )}
        >
          I already have an account, take me to log in
        </B2>
      </TextLink>
      <hr
        className={tw(
          "border-unassumingGray" as TArgument,
          "block",
          "py-12",
          "container:py-16"
        )}
      />

      <form
        onSubmit={form.handleSubmit(properties.onSubmit)}
        className={tw("space-y-16")}
      >
        {fields.map((it) => getInput(it, { key: it }))}
        <Errors errors={properties.error} />
        <div className={tw("text-center", "space-y-8")}>
          {submitButton("Sign Up")}
          <p className={tw("text-black", "text-sm", "pb-4", "container:py-8")}>
            By signing up, you agree to accept our{" "}
            <TextLink
              href={"http://example.com"}
              target={"_blank"}
              className={tw("font-bold")}
            >
              Terms
            </TextLink>{" "}
            and{" "}
            <TextLink
              href={"http://example.com"}
              target={"_blank"}
              className={tw("font-bold")}
            >
              Privacy Policy
            </TextLink>
          </p>

          <hr
            className={tw(
              "border-unassumingGray" as TArgument,
              "block",
              "py-2",
              "container:py-8"
            )}
          />

          <B1>Already have an account?</B1>
          <Button href={"/login"} color="sand">
            Log In
          </Button>
        </div>
      </form>
    </div>
  );
};
